import { Component, OnInit, Inject } from '@angular/core';
import {AuthService} from '../services/auth.service';
import {MDCTextField} from '@material/textfield';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-fgpassword',
  templateUrl: './fgpassword.component.html',
  styleUrls: ['./fgpassword.component.css']
})
export class FgpasswordComponent implements OnInit {
  email: string;
  errorMessage: string;
  constructor(public auths: AuthService, public dialog: MatDialog, public dialogRef: MatDialogRef<FgpasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.email = '';
    this.errorMessage = '';
  }

  ngOnInit() {
    const email = new MDCTextField(document.querySelector('.email-reset'));

    this.auths.errorAuth.subscribe((error) => {
      this.errorMessage = error;
    });
  }
  submitForgetPassword() {
    this.auths.passwordForgetEmail(this.email);
  }

}
